import { Warrant } from './../../models/warrant.entity';
import http, { HttpSuccessOrErrorType } from '../http';
import { Condition, KeyValue, ResultSetHeader, WarrantCode, WarrantI18NCollectionPoint, WarrantCollectionCode, WarrantI18N, WarrantSortKeyByType } from '../../models';

export default {
    /**
     * 查看餐馆warrant资源。
     * @param string_id 餐厅string_id
     */
    async get_warrant_condition(params: { string_id: string, sort_value: string } & Omit<Condition, 'sort_value'> & KeyValue): Promise<HttpSuccessOrErrorType<WarrantSortKeyByType>> {
        const { string_id, ...rest } = params;
        return await http.get(`/restaurant/${string_id}/warrant/condition`, {
            params: {
                ...rest
            }
        })
    },

    /**
     * 删除餐厅warrant资源。
     * @param params 参数
     */
    async delete_warrant_ids(params: { string_id: string, ids: Array<string> }): Promise<HttpSuccessOrErrorType<ResultSetHeader>> {
        const { string_id, ...rest } = params;
        return await http.delete(`/restaurant/${string_id}/warrant`, {
            data: {
                ...rest
            }
        })
    },

    /**
     * 创建餐厅warrant资源。
     * @param params 参数
     */
    async create_warrant(params: Warrant & { string_id: string }): Promise<HttpSuccessOrErrorType<ResultSetHeader>> {
        const { string_id, ...rest } = params;
        return await http.post(`/restaurant/${string_id}/warrants`, {
            ...rest
        })
    },

    /**
     * 修改餐厅warrant资源。
     * @param params 参数
     */
    async patch_warrant(params: Warrant & { string_id: string; current_time_zone: string }): Promise<HttpSuccessOrErrorType<ResultSetHeader>> {
        const { string_id, ...rest } = params;
        return await http.patch(`/restaurant/${string_id}/warrants`, {
            ...rest
        })
    },

    /**
     * 查看静态warrant资源。
     * @param string_id 餐厅string_id
     */
    async get_static_warrant(params: { key: string }): Promise<HttpSuccessOrErrorType<WarrantSortKeyByType>> {
        return await http.get(`/restaurant/static_warrant`, {
            params: {
                ...params
            }
        })
    },

    /**
     * 批量创建warrant资源。
     * @param params 参数
     */
    async create_warrants_collection(params: { string_id: string, code?: WarrantCode | WarrantCollectionCode, warrants: Array<Warrant> }): Promise<HttpSuccessOrErrorType<ResultSetHeader>> {
        const { string_id, ...rest } = params;
        return await http.post(`/restaurant/${string_id}/warrants_collection`, {
            ...rest
        })
    },

    /**
     * 获取餐厅授权（到期小于90天）
     */
    async getRestaurantWarrants(params: { string_id: string, type: 'USE' | 'EXPIRED' }): Promise<HttpSuccessOrErrorType<{ warrants: Warrant[] }>> {
        const { string_id, ...other } = params;
        return await http.get(`/restaurant/${string_id}/warrants`, {
            params: other
        })
    },

    /**
     * 获取所有授权点, 授权包
     */
    async getWarrantI18N(): Promise<HttpSuccessOrErrorType<WarrantI18NCollectionPoint>> {
        return await http.get(`/warrant_i18n/condition`)
    },


    async get_product_id_id(_id: string): Promise<HttpSuccessOrErrorType<WarrantI18N>> {
        return await http.get(`/warrant_i18n/${_id}?key=ALL`)
    },

    async patch_product_id_id_info(_id: string, param: WarrantI18N): Promise<HttpSuccessOrErrorType<WarrantI18N>> {
        return await http.patch(`/warrant_i18n/${_id}`, {
            ...param
        })
    },

    /**
     * 检查授权点状态
     */
    async check_warrant_code(params: { string_id: string, code: WarrantCode }): Promise<HttpSuccessOrErrorType<{ passedWarrant: { isPass: boolean }[], unpassedWarrant: { isPass: boolean }[] }>> {
        return await http.get(`/restaurant/${params.string_id}/check_warrant/${params.code}`, {

        })
    },

}